module.exports = __webpack_public_path__ + "static/media/contact.af2cf0cd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/contact.svg
// module id = 1285
// module chunks = 1